import {createFileRoute} from '@tanstack/react-router'
import KotcView_Create from "../../../kotc/KotcView_Create.tsx";

export const Route = createFileRoute('/_app/kotc/create')({
    component: RouteComponent,
})

function RouteComponent() {
    return <KotcView_Create />
}
